import React, { useState, useContext, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { AuthContext } from "../../Contexts/auth";
import styles from './CreateAccount.module.css';
import CondText from '../../Components/SideBar/assets/icons/condbot-login.png';
import LayoutDefault from '../../Components/LayoutDefault/LayoutDefault';
import PhoneInput from "react-phone-input-2";

const CreateAccount = () => {
  const [name, setName] = useState("");
  const [cpfcnpj, setCpfcnpj] = useState("");
  const [birthDate, setBirthDate] = useState("");
  const [phone, setPhone] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [authorizedError, setAuthorizedError] = useState(false);
  const [country, setCountry] = useState("");

  const { createAccount } = useContext(AuthContext);
  const navigate = useNavigate();

  const handleSubmit = async (event) => {
    event.preventDefault();

    const parameters = {
      name: name,
      username: null,
      cpfCnpj: cpfcnpj ? Number(cpfcnpj) : null,
      email: email,
      phone: phone,
      password: password,
      isActive: 'S'
    };

    try {
      await createAccount(parameters);
    } catch (error) {
      setAuthorizedError(true);
    }
  };

  useEffect(() => {
    fetch("https://ipwho.is/")
      .then((res) => res.json())
      .then((data) => {
        if (data?.country_code?.toLowerCase() === "br") {
          setCountry("br");
        }
      })
      .catch((err) => console.warn("Erro ao detectar país:", err));
  }, []);

  function maskCpfCnpj(value) {
    const digits = value.replace(/\D/g, '').slice(0, 14);

    if (digits.length <= 11) {
      // CPF
      return digits
        .replace(/(\d{3})(\d)/, '$1.$2')
        .replace(/(\d{3})(\d)/, '$1.$2')
        .replace(/(\d{3})(\d{1,2})$/, '$1-$2');
    }

    // CNPJ
    return digits
      .replace(/(\d{2})(\d)/, '$1.$2')
      .replace(/(\d{3})(\d)/, '$1.$2')
      .replace(/(\d{3})(\d)/, '$1/$2')
      .replace(/(\d{4})(\d{1,2})$/, '$1-$2');
  }


  return (
    <LayoutDefault>
      <div className={styles.mainPanelCreateAccount}>

        <div className={styles.imageContent}>
          <img src={CondText} alt="Imagem explicativa sobre o CondoBot" className={styles.imageImg} />
        </div>

        <div className={styles.CreateAccountPanel}>
          <div className={styles.CreateAccount}>

            <div className={styles.siteDescription}>
              <h1>Criar nova conta</h1>
            </div>

            <form className={styles.form} onSubmit={handleSubmit}>
              <div className={styles.field}>
                <label style={{ color: '#7e7575' }}>Nome completo</label>
                <input
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                  required
                  style={{ color: '#7e7575' }}
                />
              </div>

              <div className={styles.field}>
                <label style={{ color: '#7e7575' }}>Data de nascimento</label>
                <input
                  type="date"
                  value={birthDate}
                  onChange={(e) => setBirthDate(e.target.value)}
                  required
                  style={{ color: '#7e7575' }}
                />
              </div>

              <div className={styles.field}>
                <label style={{ color: '#7e7575' }}>CPF/CNPJ</label>
                <input
                  value={cpfcnpj}
                  onChange={(e) => setCpfcnpj(maskCpfCnpj(e.target.value))}
                  required
                  style={{ color: '#7e7575' }}
                />
              </div>

              <div className={styles.field}>
                <label style={{ color: '#7e7575' }}>Celular</label>
                <PhoneInput
                  value={phone}
                  country={null}
                  onFocus={() => {
                    if (!phone && country === 'br') {
                      setPhone('+55');
                    }
                  }}
                  onChange={(val) => setPhone(val)}
                  inputStyle={{ width: '100%', height: '40px' }}
                  enableSearch
                  placeholder={'(99) 99999-9999'}
                  masks={{ br: '(..) .....-....' }}
                  localization={{
                    br: 'Brasil',
                    us: 'Estados Unidos',
                    gb: 'Reino Unido',
                    fr: 'França',
                    de: 'Alemanha',
                    search: 'Buscar',
                  }}
                />
              </div>

              <div className={styles.field}>
                <input
                  placeholder="Email"
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                />
              </div>

              <div className={styles.field}>
                <input
                  placeholder="Nova senha"
                  type="password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  required
                />
              </div>

              {authorizedError && (
                <div className={styles.responseCreateAccount}>
                  <span className={styles.error}>Erro ao criar conta. Verifique os dados.</span>
                </div>
              )}

              <div className={styles.actions}>
                <button className={styles.buttonCreateAccount} type="submit">
                  Criar conta
                </button>
              </div>
            </form>

            <div className={styles.goToLogin}>
              <button
                onClick={() => navigate("/login")}
                className={styles.linkButton}
                type="button"
              >
                Já tem uma conta?
              </button>
            </div>
          </div>
        </div>
      </div>
    </LayoutDefault>
  );
};

export default CreateAccount;
